import dayjs from "dayjs";
import { FormModel } from "../types/FormTypes";

export function mapFormDataToPayload(formData: FormModel) {
    const formatTimeToIso = (isoDate: string, timeRange: string) => {
        const [departure] = timeRange.split(" - ");
        const date = dayjs(isoDate).format("YYYY-MM-DD");
        return dayjs(`${date} ${departure}`, "YYYY-MM-DD HH:mm").toISOString();
    };

    const formatArrivalToIso = (isoDate: string, timeRange: string) => {
        const [, arrival] = timeRange.split(" - ");
        const date = dayjs(isoDate).format("YYYY-MM-DD");
        return dayjs(`${date} ${arrival}`, "YYYY-MM-DD HH:mm").toISOString();
    };

    const sanitizeOgtType = (ogtType?: string): string => {
        return ogtType === "custom" || !ogtType ? "stop" : ogtType;
    };

    const formatPartialJourney = (journey: any): any => {

        return {
            DateOfJourney: formatTimeToIso(journey.unformattedDate, journey.travelTime),
            ArrivalDateOfJourney: formatArrivalToIso(journey.unformattedDate, journey.travelTime),
            JourneyKey: journey.journeyKey,
            RouteLinks: Array.isArray(journey.line)
                ? journey.line.map((link: any) => ({
                      DepDateTime: dayjs(link.DepDateTime).toISOString(),
                      LineNrReal: link.Line?.LineNrReal,
                      LineName: link.Line?.LineName,
                      RunNo: link.Line?.RunNo,
                      RouteLinkKey: link.RouteLinkKey,
                      RouteLinkGroupType: link.Line?.Ogt?.OgtTrafficTypeGroupKey ?? "",
                      StopIds: link.Line?.PointsOnRouteLink?.map((point: any) => ({ stopId: point.Id })) ?? []
                  }))
                : [],
                From: {
                    PlaceId: journey.UsedStartPlace.Id || "",
                    PlaceName: journey.UsedStartPlace?.PlaceName || journey.fromName || "",
                    OgtType: sanitizeOgtType(journey.UsedStartPlace?.OgtType)
                  },
                  To: {
                    PlaceId: journey.UsedEndPlace.Id || "",
                    PlaceName: journey.UsedEndPlace?.PlaceName || journey.toName || "",
                    OgtType: sanitizeOgtType(journey.UsedEndPlace?.OgtType)
                  }
        };
    };

    const payload = {
        ContactName: formData.contactperson ?? "",
        PhoneContact: formData.phonenumber ?? "",
        Email: formData.mailadress ?? "",
        OrganisationName: formData.schoolorg ?? "",
        PhoneOrganisation: formData.phonenumberschoolorg ?? "",
        NumTravelers: Number(formData.travelQty) || 0,
        PartialJourneys: [
            formatPartialJourney(formData.selectedJourney),
            ...(formData.traveltype === "round_trip" && formData.selectedReturnJourney?.journeyKey
                ? [formatPartialJourney(formData.selectedReturnJourney)]
                : [])
        ]
    };
    return payload;
}
